import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Button, InputX, Select, InputRed, LayerBottom, Layer, NoData } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import tabStyles from "css/Tab.module.css"
import layerStyles from 'css/Layer.module.css'
import { showQuestionLayerState, moreQuestPost } from 'views/setting/states'
import useStateWithValidation from 'hooks/useStateWithValidation'
import { useRecoilState } from 'recoil'
import Lib from 'library';
import axios from 'axios'
import LinesEllipsis from 'react-lines-ellipsis'

const Question = () => {

	const App = useApp()
	const [showQuestionLayer, setShowQuestionLayer] = useRecoilState(showQuestionLayerState)
	const [morePage, setMorePage] = useRecoilState(moreQuestPost);

	const [questionType, setQuestionType, isValidQuestionType] = useStateWithValidation(type => {
		const t = Lib.isNotNull(type)
		return t
	}, null)
	const [target, setTarget] = useState(0); // 탭 target
	const [email, setEmail, isValidEmail] = useStateWithValidation(email => /^.+@[^.]+\..+$/.test(email), null)
	const [byte, setByte, isValidByte] = useStateWithValidation(byte => byte >= 1 && byte <= 500, 0)
	const [companyNm, setCompanyNm, isValidCompanyNm] = useStateWithValidation(companyNm => Lib.isNotNull(companyNm), null)
	const [managerNm, setManagerNm, isValidManagerNm] = useStateWithValidation(managerNm => Lib.isNotNull(managerNm), null)
	const [managerNo, setManagerNo, isValidManagerNo] = useStateWithValidation(managerNo => /^\d{10,11}$/.test(managerNo), "")

	const [showTerms, setShowTerms] = useState(false)
	const [questType, setQuestType] = useState(0)
	const [questionTypeRed, setQuestionTypeRed] = useState(false)
	const [emailRed, setEmailRed] = useState(false)
	const [byteRed, setByteRed] = useState(false)
	const [companyNmRed, setCompanyNmRed] = useState(false)
	const [managerNmRed, setManagerNmRed] = useState(false)
	const [managerNoRed, setManagerNoRed] = useState(false)

	const [originalData, setOriginalData] = useState([])
	const [byteText, setByteText] = useState("문의내용은 1자이상 입력 해 주세요.")
	const [data, setData] = useState([])
	const [qList, setQList] = useState()
	const [qList1, setQList1] = useState()
	const [qList2, setQList2] = useState()
	const [showDetailLayer, setShowDetailLayer] = useState(false)
	const [qText, setQText] = useState()
	const [detailId, setDetailId] = useState()
	const [checked, setChecked] = useState(false)
	const [buttonDisabled, setButtonDisabled] = useState(true)

	const [showOpenFilter, setShowOpenFilter] = useState(false)
	//조회필터
	const [beforeMonth, setBeforeMonth] = useState();
	const [tradeStartDe, setTradeStartDe] = useState(); // 거래시작일자
	const [tradeEndDe, setTradeEndDe] = useState(); // 거래 종료일자
	const [commCodeTradeTp, setCommCodeTradeTp] = useState(); //문의구분 공통코드
	const [tradeClassCd, setTradeClassCd] = useState(); // 문의 구분코드
	const [answerStatus, setAnswerStatus] = useState(); //문의 답변상태 공통코드
	const [answerCd, setAnswerCd] = useState(); //문의 답변상태
	

	const inputRef0 = useRef();
	const inputRef1 = useRef();
	const inputRef2 = useRef();
	const [imgBase64, setImgBase64] = useState(""); // 파일 base64
	const [imgFile, setImgFile] = useState("");	//파일	
	const [viewImgFile0, setViewImgFile0] = useState(null);	//파일
	const [viewImgFile1, setViewImgFile1] = useState(null);	//파일
	const [viewImgFile2, setViewImgFile2] = useState(null);	//파일
	const [image0, setImage0] = useState(null);	//파일
	const [image1, setImage1] = useState(null);	//파일
	const [image2, setImage2] = useState(null);	//파일

	const [activeTab, setActiveTab] = useState(0)

	const page = useRef(1)

	const [num, setNum] = useState(1) //페이지 

	const [readYn, setReadYn] = useState()

	const [infiniteN, setInfiniteN] = useState(1); // 무한 스크롤 숫자
	const layerWin = useRef()

	const first = useRef(false)
	const scrollPage = useRef()
	const isLoading = useRef(false)

	const noMore = useRef(false)



	// 문의유형 '개인정보 열람청구' 처리
	const [prvcPrslType, setPrvcPrslType] = useState(false); // 열람청구 선택했는지
	const [name, setName] = useState(''); // 사용자 성명
	const [tell, setTell] = useState(''); // 사용자 전화번호
	const [birth, setBirth] = useState(''); // 사용자 생년월일



	const openTerms = () => {
		setShowTerms(true)
	}

	const closeTerms = () => {
		setShowTerms(false)
	}

	//문의내역 상세화면 //여기여기
	const showDetail = (id) => {
		setDetailId(id)
		setShowDetailLayer(true)
		//문의 내용 클릭 시 questUserReadYn 업데이트
		Lib.post(`/api/more/cstmr/srvc/inqry/upd`, {
			mbId: App.user?.mbId,
			sno: id
		}, data => {
			noMore.current = false
		})
	}

	//문의하기 목록 데이터 가져오기
	const getData = useCallback((n) => {
		// console.log(`noMore.current: ${noMore.current}`);
		if (noMore.current) return
		if (typeof n !== "undefined") page.current = n
		isLoading.current = true
		let rowsPerPage = 10
		const param = {
			stDt: tradeStartDe,
			enDt: tradeEndDe,
			questTpCd: tradeClassCd,
			aswerProcsStusCd: answerCd,
			rowsPerPage: rowsPerPage,
			pageNo: typeof n !== "undefined" ? n : page.current
		}

		Lib.get(`/api/more/cstmr/srvc/inqry/hist`, param,
			data => {
				isLoading.current = false
				if (data.length === 0) {
					noMore.current = true
					if (page.current === 1) {  //페이지 늘어났을 때 데이터 다 사라지는 것 방지
						setData(data)
					}
				} else {
					if (data.length < rowsPerPage) noMore.current = true //가져온 데이터가 rowsPerPage보다 적으면 더이상 데이터 가져오지 않기
					setOriginalData(data)
					// setData(prevState => prevState.concat(data));
					if (n > 1) {
						setData(prevState => [
							...prevState,
							...data
						]);
					} else {
						setData(data)
					}

					//page.current++
				}
			})
	}, [tradeStartDe, tradeEndDe, tradeClassCd, answerCd, beforeMonth])

	// 삭제 - 김동영
	// useEffect(() => {
	// 	noMore.current = false
	// 	getData()
	// }, [tradeStartDe, tradeEndDe, tradeClassCd, answerCd, beforeMonth])

	//문의하기 레이어가 열릴 때 데이터 전송
	useEffect(() => {
		if (showQuestionLayer) {
			getCommonCodeList()
			reset1()
			setQuestType(0)
			// getData()
		}
		if (showQuestionLayer === false) {
			reset2()
			setTarget(0)
			setActiveTab(0)
		}
	}, [showQuestionLayer])

	useEffect(() => {
		reset1()
		setQuestType(0)
		reset2()
	}, [activeTab])

	//필드값 초기화
	const reset1 = () => {
		setChecked(false)
		//setQuestType(0)
		// getCommonCodeListInqry()
		// getCommonCodeList()
		//조회필터
		setBeforeMonth()
		setTradeStartDe()
		setTradeEndDe()
		setTradeClassCd()
		setAnswerCd()
		//문의하기 필드 값
		setCompanyNm()
		setManagerNm()
		setManagerNo()
		setEmail()
		setByte()
		setQuestionType(null)
		setQText("")
	}
	useEffect(() => {

	}, [questionType])

	const reset2 = () => {
		//경고 문구 초기화
		setEmailRed(false)
		setQuestionTypeRed(false)
		setByteRed(false)
		setCompanyNmRed(false)
		setManagerNmRed(false)
		setManagerNoRed(false)
		setQuestionType(null)
		setViewImgFile0(null)
		setImage0()
		setViewImgFile1(null)
		setImage1()
		setViewImgFile2(null)
		setImage2()
		setPrvcPrslType(false)
		
	}

	// 문의구분별 문의유형 공통코드값 가져오기
	useEffect(() => {
		if (showQuestionLayer === true) {
			Lib.get(`/api/comm/cd/INQRY_CLSFC`, data => {
				setQList1(data.map(item => {
					return { key: item.commNm, value: item.commCd }
				}))
			})
			Lib.get(`/api/comm/cd/INQRY_BSNSS`, data => {
				setQList2(data.map(item => {
					return { key: item.commNm, value: item.commCd }
				}))
			})
		}
	}, [showQuestionLayer])

	// 공통코드 조회 (문의구분, 답변상태)
	const getCommonCodeList = async () => {
		const list = await Lib.getCommonCode("INQRY_CLASS_TP") // 문의구분 (사업제휴문의, 사용자문의)
		if (list && list.length > 0) {
			setCommCodeTradeTp(list.map(item => {
				return {
					key: item.commNm,
					value: item.commCd
				}
			}))
		}

		const answerList = await Lib.getCommonCode("INQRY_STUS")

		if (answerList && answerList.length > 0) {
			const filterAnswerList = answerList.filter(item => item.commCd !== 'INQRY_DEL'); //삭제 상태구분 제외
			setAnswerStatus(filterAnswerList.map(item => {
				return {
					key: item.commNm,
					value: item.commCd
				}
			}))
		}
	}

	//유형 코드 비교해서 값 가져오기
	const getQnaType = (code) => {
		if (!code || !qList) return null
		let result = null
		qList.forEach(item => {
			if (item.value === code) {
				result = item.key
			}
		})
		return result
	}

	//문의유형 선택 시
	const onSelectQuestionType = (key, value) => {
		console.log('문의유형선택', key, value)
		setQuestionTypeRed(true)
		setQuestionType(value)
		// 개인정보 열람청구 별도 처리
		if(value === 'PRVC_PRSL'){
			setPrvcPrslType(true)
		}else{
			setPrvcPrslType(false)
		}
	}

	useEffect(() => {
		if (prvcPrslType === true &&
			name === '' &&
			tell === '' &&
			birth === ''
			) {
			setName(App.user?.mbNm)
			setTell(App.user?.cphNo)
			setBirth(App.user?.birthDe)
		}
	}, [prvcPrslType])


	const onCheckClick = () => {
		setChecked(checked => !checked)
	}

	// email 타입
	const onChangeEmail = e => {
		setEmailRed(true)
		setEmail(e.target.value)

		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			setEmail(email)
		}
	}
	useEffect(() => {
		setEmail(email)
		if (email === '') {
			setEmail(undefined)
		}
	}, [email])

	//회사명
	const onChangeCompanyNm = e => {
		setCompanyNmRed(true)
		setCompanyNm(e.target.value)

		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			setCompanyNm(companyNm)
		}
	}
	useEffect(() => {
		setCompanyNm(companyNm)
		if (companyNm === '') {
			setCompanyNm(undefined)
		}
	}, [companyNm])

	//담당자명
	const onChangeManagerNm = e => {
		setManagerNmRed(true)
		setManagerNm(e.target.value)

		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			setManagerNm(managerNm)
		}
	}
	useEffect(() => {
		setManagerNm(managerNm)
		if (managerNm === '') {
			setManagerNm(undefined)
		}
	}, [managerNm])

	//연락처
	const onChangeManagerNo = e => {
		setManagerNoRed(true)
		setManagerNo(e.target.value)

		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			setManagerNo(managerNo)
		}
	}
	useEffect(() => {
		setManagerNo(managerNo)
		if (managerNo === '') {
			setManagerNo(undefined)
		}
	}, [managerNo])

	// 문의내용 변경시
	const onChangeQuestionContent = e => {
		setByteRed(true)
		const value = e.target.value
		const length = value.length

		const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
		if (regex.test(e.target.value)) {
			App.alert('이모티콘은 사용할 수 없습니다.')
			return value.replace(regex, '')
		}

		if (length <= 2) {
			setByteText("문의내용은 1자이상 입력 해 주세요.")
		} else {
			setByteText("문의내용은 500자를 초과할 수 없습니다.")
		}
		setByte(length)
		setQText(value)
	}

	const validate = () => {
		setEmailRed(true)
		setQuestionTypeRed(true)
		setByteRed(true)

		if (questType === 1) {
			setCompanyNmRed(true)
			setManagerNmRed(true)
			setManagerNoRed(true)

			if (!isValidCompanyNm) return false
			if (!isValidManagerNm) return false
			if (!isValidManagerNo) return false
		}

		if (!checked) return false
		if (!isValidEmail) return false
		if (!isValidQuestionType) return false
		if (!isValidByte) return false

		return true
	}

	useEffect(() => {
	 	//console.log("[first.current : " + first.current + "]");
		if (first.current) setButtonDisabled(!validate())
	 	first.current = true
	}, [isValidQuestionType, isValidEmail, isValidByte, isValidManagerNm, isValidManagerNo, isValidCompanyNm, checked, questType])

	const questType0 = () => {
		first.current = false
		setQuestType(0)
		reset1()
		reset2()
		setEmail(App.user?.email)
	}
	const questType1 = () => {
		first.current = false
		setQuestType(1)
		reset1()
		reset2()
		setEmail(App.user?.email)
	}

	//image
	const handleChangeFile = (event) => {

		for (var i = 0; i < event.target.files.length; i++) {
			let object = new Object();

			object = {
				no: clickIndex,
				file: event.target.files[i]
			}
			let files = [image0?.file, image1?.file, image2?.file]
			files[clickIndex] = event.target.files[i]
			files =files.filter(file => file !== null && file !== undefined)
			
			// 단일 파일 체크 => clickindex기준으로 하나의 이벤트 처리됨
			if(!checkSize(files)){
				App.alert('최대 10MB를 넘을 수 없습니다.')
				return
			}
			
			if (clickIndex === 0) {
				setImage0(object)
				setViewImgFile0(URL.createObjectURL(event.target.files[0]))
			}
			if (clickIndex === 1) {
				setImage1(object)
				setViewImgFile1(URL.createObjectURL(event.target.files[0]))
			}
			if (clickIndex === 2) {
				setImage2(object)
				setViewImgFile2(URL.createObjectURL(event.target.files[0]))
			}
		}
	}

	// checkFileSize
	const checkSize = (files) =>{
		const maxSize = 10 * 1024 * 1024 // 10MB
		if(files.length == 1){
			if(files[0].size > maxSize){
				return false
			}
		}else{
			let totalSize = 0
			for (const file of files) {
				totalSize += file.size
			}
			if(totalSize > maxSize){
				return false
			}

		}
		return true
	}
	
	// 파일 삭제 
	const deleteImage = (index) => {
		// 	setViewImgFile("");
		// 	setImgFile("")
		// 	// document.querySelector('.modify-img').style.display = 'none'

		if (index === 0) {
			setViewImgFile0(null)
			setImage0()
			if (inputRef0.current) {
				inputRef0.current.value = ''
			}
		}
		if (index === 1) {
			setViewImgFile1(null)
			setImage1()
			if (inputRef1.current) {
				inputRef1.current.value = ''
			}
		}
		if (index === 2) {
			setViewImgFile2(null)
			setImage2()
			if (inputRef2.current) {
				inputRef2.current.value = ''
			}
		}

	};

	let clickIndex;
	const onbuttonClick = (index) => {
		// event.preventDefault();
		
		clickIndex = index;
		if (index === 0) {
			inputRef0.current.click();
		}
		if (index === 1) {
			inputRef1.current.click();
		}
		if (index === 2) {
			inputRef2.current.click();
		}
	}

	//등록하기 버튼 클릭
	const onRegister = () => {
		if (!validate()) return

		App.showLoading()
		let files = []
		if (image0) { files.push(image0.file) }
		if (image1) { files.push(image1.file) }
		if (image2) { files.push(image2.file) }
		// 파일 첨부시 체크하나 마지막에 다시 한번 체크
		if(!checkSize(files)){
			App.alert('최대 10MB를 넘을 수 없습니다.')
			App.hideLoading();
			return
		}
		const fd = new FormData()
		for (const file of files) {
			fd.append("questAtchFileList", file)
		}

		fd.append("qnaTpCd", questionType);
		fd.append("questConts", qText);
		fd.append("questTpCd", questType === 1 ? "BSNS_INQRY" : "USER_INQRY");
		fd.append("questUserEmail", email);
		if (questType === 1) {
			fd.append("questUserCmpnyNm", companyNm);
			fd.append("questUserNm", managerNm);
			fd.append("questUserTphNo", managerNo);
		}

		axios.post(`/api/more/cstmr/srvc/inqry/ins`, fd, {
			headers: {
				"Content-Type": `multipart/form-data; `,
			},
			maxBodyLength: 3 * 1024,
		})
			.then((response) => {
				if (response.data.code === "S000") {
					getData()
					App.alert("등록이 완료되었습니다.")
					setViewImgFile0(null)
					setImage0()
					setViewImgFile1(null)
					setImage1()
					setViewImgFile2(null)
					setImage2()
					setChecked(false)
					reset1()
					setQuestType(0)
					reset2()

					// setTarget(1)
					setActiveTab(1)
					App.hideLoading();
					layerWin.current.querySelector(`.${layerStyles.wrap}`).scrollTo(0, 0) //스크롤 top 이동
				} else {
					alert(`[${response.data.code}] ${response.data.msg}`)
					App.hideLoading();
				}
			})
			.catch((error) => {
				console.log("error", error);
				App.alert(`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`)
				App.hideLoading();
			})
	}

	/* useEffect(() => {
		let observer;
			// callback 함수, option
			observer = new IntersectionObserver(onIntersect, {
				threshold: 0.4,
			});
			observer.observe(); // 타겟 엘리먼트 지정
		
		return () => observer && observer.disconnect();
	}, []); */

	const onDetail = id => {
		setDetailId(id)
		setShowDetailLayer(true)
		//문의 내용 클릭 시 questUserReadYn 업데이트
		Lib.post(`/api/more/cstmr/srvc/inqry/upd`, {
			mbId: App.user?.mbId,
			sno: id
		}, d => {
			const newData = data.map(item => {
				const newItem = { ...item }
				if (item.sno === id) newItem.questUserReadYn = "Y"
				return newItem
			})
			setData(newData)
		})
	}

	const bindScroll = () => {
		const layerWrap = layerWin.current.querySelector(`.${layerStyles.wrap}`)
		const wrapPadding = layerWin.current.querySelector(`#wrapPadding`)
		const screenHeight = window.screen ? window.screen.height : window.innerHeight
		if (layerWrap) {
			layerWrap.addEventListener("scroll", e => {
				if (noMore.current) return
				const scrollTop = layerWrap.scrollTop
				const rect = wrapPadding.getBoundingClientRect()
				const top = rect.top
				const height = rect.height
				if (((height + top) - screenHeight) <= scrollTop) {
					if (!isLoading.current) setMorePage(prevStus => prevStus + 1);
					//if (!isLoading.current) getData()
				}
			})
		}
	}

	useEffect(() => {
		if (activeTab === 0) {
			setMorePage(1)
		} else if (activeTab === 1) {
			setQList([...qList1, ...qList2])
			noMore.current = false;
			getData(morePage);
			// scrollPage.current.scrollIntoView()
			if (morePage === 1) {
				layerWin.current.querySelector(`.${layerStyles.wrap}`).scrollTo(0, 0)
			}
		}
	}, [morePage, tradeStartDe, tradeEndDe, tradeClassCd, answerCd, beforeMonth, activeTab])

	useEffect(() => {
		if (showQuestionLayer) {
			setEmail(App.user?.email)
			if (activeTab === 0) {
				layerWin.current.querySelector(`.${layerStyles.wrap}`).scrollTo(0, 0)
				setMorePage(1)
				noMore.current = false;
				setData([]);
			} else if (activeTab === 1) {
				bindScroll()
			}
		} else {
			setMorePage(1)
		}

	}, [showQuestionLayer, activeTab])

	const closeQuestion = () => {
		if (qText === '') {
			setShowQuestionLayer(false)
		} else {
			App.showAlert({
				msg: "페이지를 이동하면 저장된 내용을 모두 잃게 됩니다. 그래도 진행하시겠어요?",
				ok: "확인",
				cancel: "취소",
				confirm: true,
				onOk: () => setShowQuestionLayer(false),
			})
		}
	}

	return (
		<Layer show={showQuestionLayer} closeLayer={() => closeQuestion()} ref={layerWin}>
			<div className="page" ref={scrollPage}>
				<div className="flex_1" id="wrapPadding">
					<ul className={tabStyles.Tabs}>
						<li className={`${tabStyles.tab} ${activeTab === 0 ? tabStyles.on : ""}`} onClick={() => setActiveTab(0)}><span>문의하기</span></li>
						<li className={`${tabStyles.tab}  ${activeTab === 1 ? tabStyles.on : ""}`} onClick={() => setActiveTab(1)}><span>문의내역</span></li>
					</ul>
					{
						activeTab === 0 &&
						<>
							<div className="mt_30">
								<div>
									<ul className="tab-scroll">
										<li onClick={() => questType0()} className={questType === 0 ? "active" : undefined}>사용자문의</li>
										<li onClick={() => questType1()} className={questType === 1 ? "active" : undefined}>사업제휴문의</li>
									</ul>
								</div>

								{/* 사용자문의 / 사업제휴문의 구분 */}
								<div className="padding rmv">
									{
										questType === 1 &&
										<>
											<p className="guide-title">회사명</p>
											<InputX type="text" placeholder="회사명 입력" id="" className="mt_10" value={companyNm || ''} onX={() => { setCompanyNm() }} onChange={onChangeCompanyNm} />
											<InputRed text="회사명은 필수로 입력하셔야 합니다." show={companyNmRed && !isValidCompanyNm} />

											<p className="guide-title mt_30">담당자명</p>
											<InputX type="text" placeholder="담당자명 입력" id="" className="mt_10" value={managerNm || ''} onX={() => { setManagerNm() }} onChange={onChangeManagerNm} />
											<InputRed text="담당자명은 필수로 입력하셔야 합니다." show={managerNmRed && !isValidManagerNm} />

											<p className="guide-title mt_30">연락처</p>
											<InputX type="text" placeholder="연락처 입력" id="" className="mt_10" value={managerNo || ''} onX={() => { setManagerNo() }} onChange={onChangeManagerNo} maxlength="11" />
											<InputRed text="숫자 10~11자로 입력해주세요." show={managerNoRed && !isValidManagerNo} />
										</>
									}
									<p className="guide-title mt_30">이메일 주소</p>
									<InputX type="email" placeholder="이메일 주소 입력" id="" className="mt_10" value={email || ''} onX={() => {
										setEmail()
									}} onChange={onChangeEmail} />
									{!prvcPrslType
										? <InputRed text="이메일은 필수로 입력하셔야 합니다." show={emailRed && !isValidEmail} />
										: <InputRed text="*내 정보에 등록된 이메일 주소와 동일한 이메일 주소를 입력해 주셔야 개인정보 열람청구 문의가 가능합니다." show={prvcPrslType}/>
									}

									<p className="guide-title mt_30">문의유형</p>
									<Select className="mt_10" placeholder="문의유형선택" title="문의유형" selected={questionType} data={questType === 0 ? qList1 : qList2} onSelect={onSelectQuestionType} />
									<InputRed text="문의유형은 필수로 선택하셔야 합니다." show={questionTypeRed && !isValidQuestionType} />

									<p className="guide-title mt_30">문의내용</p>
									<div className="form-group mt_10">
										<div className="write-area-box">
											<textarea placeholder="문의내용을 입력해주세요." maxLength={500} className="write-area" style={{ minHeight: "5rem" }} onChange={onChangeQuestionContent} value={qText} />
											<span className="float-count"><span className="text-blue">{!byte ? 0 : byte}</span>/500</span>
										</div>
									</div>
									<InputRed text={byteText} show={byteRed && !isValidByte} />
									{!prvcPrslType &&
									<>
										<p className="guide-title mt_30">첨부파일</p>
										<div className="photo-add mt_10">
											<div>
												<div className="img-box" onClick={() => { onbuttonClick(0) }}>
													<input style={{ display: "none" }} ref={inputRef0} accept='image/*' className={styles.inputFile} type="file" name="imgFile" id="imgFile0" onChange={handleChangeFile} />
													{/* <input type="file" ref={inputRef0} id="imgFile0" capture="camera" name="imgFile" accept="image/*" onChange={handleChangeFile}></input> */}
													{viewImgFile0 ?
														<img
															src={viewImgFile0}
														/>
														:
														""
													}
												</div>
												{viewImgFile0 && <i className="icon icon_file_close" onClick={() => deleteImage(0)} />}
											</div>

											<div>
												<div className="img-box" onClick={() => { onbuttonClick(1) }}>
													<input style={{ display: "none" }} ref={inputRef1} accept='image/*' className={styles.inputFile} type="file" name="imgFile" id="imgFile1" onChange={handleChangeFile} />
													{/* <input type="file" ref={inputRef1} id="imgFile1" name="imgFile" accept="image/*" onChange={handleChangeFile}></input> */}
													{viewImgFile1 ?
														<img
															src={viewImgFile1}
														/>
														:
														null
													}
												</div>
												{viewImgFile1 && <i className="icon icon_file_close" onClick={() => deleteImage(1)} />}
											</div>

											<div>
												<div className="img-box" onClick={() => { onbuttonClick(2) }}>
													<input style={{ display: "none" }} ref={inputRef2} accept='image/*' className={styles.inputFile} type="file" name="imgFile" id="imgFile2" onChange={handleChangeFile} />
													{viewImgFile2 ?
														<img
															src={viewImgFile2}
														/>
														:
														null
													}
												</div>
												{viewImgFile2 && <i className="icon icon_file_close" onClick={() => deleteImage(2)} />}
											</div>

											{/* 
											<div>
												<div className="img-box">
													<img src={fileImg} alt="" />
												</div>
												<i className="icon icon_file_close" />
											</div>
											*/}
										</div>
										<p className="photo-guide mt_20">※ 이미지 파일(GIF, JPG, PNG)만 가능하며, 최대 10MB를 넘을 수 없습니다.</p>
									</>}
									{prvcPrslType && name !== '' && tell !== '' && birth !== '' &&
									<>
										<p className="guide-title mt_30">성명</p>
										<InputX type="text" id="" className="mt_10" readOnly disabled defaultValue={name} />
										<p className="guide-title mt_20">전화번호</p>
										<InputX type="text" id="" className="mt_10" readOnly disabled defaultValue={tell} />
										<p className="guide-title mt_20">생년월일</p>
										<InputX type="text" id="" className="mt_10" readOnly disabled defaultValue={birth} />
									</>
									}
									{!prvcPrslType
									? <div className={`${styles["question-box"]} mt_40`}>
										<p>안내사항</p>
										<ul className="mt_10">
											<li>- 문의사항은 메일 또는 전화로 회신드리며, 접수일로부터 영업일 기준 7일 이내에 답변받을 수 있습니다.</li>
											<li>- 기타 문의는 고객센터(02-6956-4148)로 전화주시면 친절히 도와드리겠습니다.</li>
										</ul>
									</div>
									: <div className={`${styles["question-box"]} mt_40`}>
										<p>요구내용</p>
										<ul className="mt_10">
											<li>1. 개인정보의 항목 및 내용</li>
											<li>2. 개인정보 수집 ∙ 이용의 목적</li>
											<li>3. 개인정보 보유 및 이용기간</li>
											<li>4. 개인정보의 제 3자 제공 현황</li>
											<li>5. 개인정보 처리에 동의한 사실 및 내용</li>
										</ul>
										<p className="mt_25">처리절차</p>
										<ul className="mt_10">
											<li>근무일 기준 10일 이내</li>
										</ul>
									</div>
									}

									<div className="flex-justify_between align_center mt_40">
										<div className="chk" onClick={onCheckClick} >
											{/* <input type="checkbox" id="check1" name="" onClick={onCheckClick} /> */}
											<i className={`checkMark ${checked === true ? "on" : ""}`} />
											<label htmlFor="check1">
												<span><strong>[필수]</strong> 개인정보 수집, 이용동의</span>
											</label>
										</div>
										<i className="icon icon_arrow_sm right" onClick={openTerms} />
									</div>
									<Button id="btnRegister" className="btn btn--big mt_50" disabled={buttonDisabled} onClick={onRegister}>등록하기</Button>
								</div>
							</div>
						</>
						||
						activeTab === 1 &&
						<>
							<div className="padding" >
								{/* 문의내역 -> 데이터 있을 때 */}
								{data.length > 0 ?
									<div className="filter-group">
										<div onClick={() => setShowOpenFilter(true)}>
											<span>
												{/* {beforeMonth === 0 ? "직접설정" : beforeMonth + "개월"} */}

												{Lib.isNull(beforeMonth) ?
													"전체기간"
													: beforeMonth === 0 ? "직접설정"
														: beforeMonth + "개월"
												}∙
												{
													commCodeTradeTp && commCodeTradeTp.length > 0 && tradeClassCd ?


														commCodeTradeTp.map((item, idx) => {
															if (tradeClassCd === item.value) {
																return (item.key);
															}
														})
														:
														"전체문의"
												}∙
												{
													answerStatus && answerStatus.length > 0 && answerCd ?
														answerStatus.map((item, idx) => {
															if (answerCd === item.value) {
																return (item.key);
															}
														})
														:
														"전체상태"
												}
											</span>
											<i className="icon icon_filter ml_5" />
										</div>
									</div>
									:
									null
								}
								{data ?
									<>
										{data.length > 0?
											<ul className={`${styles["question-list"]} mt_10`}>
												{data.map((item, index) => {
													return (
														<QnaList item={item} key={index} onClick={() => onDetail(item.sno)} getQnaType={getQnaType} />
													)
												})}
											</ul>
											:
											<div className="center-cont py_100">
												<i className="icon icon_no_data" />
												<p className="mt_20">문의내역이 없어요.</p>
											</div>
										}
									</>
									:
									<NoData text="데이터를 조회중입니다." style={{ minHeight: "30rem" }} />
								}
							</div>
						</>
					}
				</div>

				<FilterLayer show={showOpenFilter} closeLayer={() => setShowOpenFilter(false)} commCodeTradeTp={commCodeTradeTp} setBeforeMonth={setBeforeMonth} setParentTradeStartDe={setTradeStartDe} setParentTradeEndDe={setTradeEndDe} setParentTradeTp={setTradeClassCd} setParentAnswerCd={setAnswerCd} answerStatus={answerStatus} target={target} activeTab={activeTab} />
				<TermsLayer show={showTerms} closeLayer={closeTerms} questType={questType} />
				<DetailLayer show={showDetailLayer} closeLayer={setShowDetailLayer} id={detailId} getQnaType={getQnaType} />

				{/* <FilterLayer show={showOpenFilter} closeLayer={() => setShowOpenFilter(false)} data={originalData} setData={setData} /> */}
			</div>
		</Layer >
	)
}

// 문의내역 목록 
const QnaList = ({ item, onClick, getQnaType }) => {

	return (
		<li onClick={onClick}>
			<div className={styles.question}>
				<div className="flex-justify_between align_center">
					<strong>[{item.questTpCd === "USER_INQRY" ? "사용자문의" : "사업제휴문의"}]</strong>
					{item.aswerProcsStusCd === "WAIT" && <i className="tag tag-round tag-gray-line">답변대기중</i>}
					{item.aswerProcsStusCd === "CMPLT" && <i className="tag tag-round tag-blue-line">답변완료</i>}
					{item.aswerProcsStusCd === "PRGRG" && <i className="tag tag-round tag-red-line">진행중</i>}
				</div>
				<div className={`${styles["question-title"]} mt_10`}>
					<span>#{getQnaType(item.qnaTpCd)}</span>
					{item.questUserReadYn === "N" && <span className={`${styles["new-dot"]} mr_5`}></span>}
                    <p>
                    <LinesEllipsis
                      text={item.questConts ?? ''}
                      maxLine='1'
                      ellipsis='...'
                      trimRight
                      basedOn='letters'
                      style={{ "overflowWrap": "break-word", "whiteSpace": "pre-wrap" }}
                    />
                    </p>
					<span>{Lib.dateFormat(item.questDe, ".") + ' ' + item.questTm}</span>
				</div>
			</div>
		</li>
	)
}

//문의내역 상세화면
const DetailLayer = (props) => {

	const [data, setData] = useState()
	const [answerImgFile, setAnswerImgFile] = useState([])
	const [answerAtherFile, setAnswerAtherFile] = useState([])

	useEffect(() => {
		if (props.show) {
			Lib.get(`/api/more/cstmr/srvc/inqry/hist/${props.id}`, data => {
				const aswerList = data.aswerMultiAtchFileList
				// 답변 파일 리스트가 있는 경우 이미지파일 / 이외의 파일로 구분
				if(!Lib.isNull(aswerList)){
					let imgFiles = []
					let atherFiles = []

					for(var i=0; i < aswerList.length; i++) {
						if (aswerList[i].orignFileNm.substr(-3) == 'png' ||
						aswerList[i].orignFileNm.substr(-3) == 'gif' ||
						aswerList[i].orignFileNm.substr(-3) == 'jpg' 
						) {
							imgFiles.push(aswerList[i])
						}else{
							atherFiles.push(aswerList[i])
						}
					}
					setAnswerImgFile(imgFiles)
					setAnswerAtherFile(atherFiles)
				}else{
					setAnswerImgFile([])
					setAnswerAtherFile([])
				}
				setData(data)
			})
		}
	}, [props.show])


	const fileDownload = (sstmFileId, fileName) => {
		Lib.reqBlobFileDownlaod(`/api/comm/appDownload/${sstmFileId}`, fileName, data => {
			console.log(data)
		})
	}
	const fileSize = (size) => {
		let unit = 'Bit'
		let unitSize = 1
		if(2 ** 3 < size && size <= 2 ** 10){
			unit = 'Byte'
			unitSize = 2 ** 3
		}else if(2 ** 10 < size && size <= 2 ** 20){
			unit = 'KB'
			unitSize = 2 ** 10
		}else if(2 ** 20 < size &&  size <= 2 ** 30){
			unit = 'MB'
			unitSize = 2 ** 20
		}else if(2 ** 40 < size && size <= 2 ** 40){
			unit = 'GB'
			unitSize = 2 ** 30
		}else if(2 ** 40 < size &&size <= 2 ** 50){
			unit = 'TB'
			unitSize = 2 ** 30
		}

		return `(${Lib.addComma((size / unitSize).toFixed(2))}${unit})`
	}
	return (
		<Layer {...props}>
			<div className="page padding">
				{data &&
					<div className={styles.question}>
						<div className="flex-justify_between align_center">
							<strong>[{data.questTpCd === "USER_INQRY" ? "사용자문의" : "사업제휴문의"}]</strong>
							{data.aswerProcsStusCd === "WAIT" && <i className="tag tag-round tag-gray-line">답변대기중</i>}
							{data.aswerProcsStusCd === "CMPLT" && <i className="tag tag-round tag-blue-line">답변완료</i>}
							{data.aswerProcsStusCd === "PRGRG" && <i className="tag tag-round tag-red-line">진행중</i>}
						</div>
						<div className={`${styles["question-title"]} mt_10`} style={{"whiteSpace": "pre-wrap", "wordWrap": "break-word"}}>
							<span>#{props.getQnaType(data.qnaTpCd)}</span>
							<p className="mt_20">{data.questConts}</p>
							<span>{Lib.dateFormat(data.questDe, ".") + ' ' + data.questTm}</span>
						</div>

						<div className={`${styles["attach-list"]} mt_20`}>
							{data.questMultiAtchFileList && data.questMultiAtchFileList.map((item, index) => {
								return (
									<div key={index} className="img-box">
										<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										{/* {console.log(item)} */}
									</div>
								)
							})}
						</div>
					</div>
				}
				{/* 하단 답변 화면 */}
				{data && data.aswerProcsStusCd === "CMPLT" &&
					<div className={`${styles["answer-area"]} mt_40`} style={{"white-space": "pre-wrap", "word-wrap": "break-word"}}>
						<strong>고객님의 문의에 대한 답변입니다.<br />
							추가적인 문의가 있으시면 다시 문의해주세요.
						</strong>
						<div className="mt_20" dangerouslySetInnerHTML={ {__html: data.aswerConts} }></div>
						<span className="mt_10">{data.aswerDe ? Lib.dateFormat(data.aswerDe, ".") + ' ' + data.aswerTm : ""}</span>
						{answerImgFile && answerImgFile.length > 0 &&
							<div className={`${styles["attach-list"]} mt_20`}>
								{answerImgFile.map((item, index) => {
									return ( 
									<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
									</div>
									)
								})}
							</div>
						}
						{answerAtherFile && answerAtherFile.length > 0 &&
							<ul className={`${styles["attach-list"]} mt_20`}>
							{answerAtherFile.map((item, index) => {
								return ( 
									<li key={index}>
										<button type='button' onClick={() => fileDownload(item.sstmFileId, item.orignFileNm)}>
											<span className={`${styles["name"]}`}>{item.orignFileNm}</span>
											<em className={`${styles["fileSize"]}`}>{fileSize(item.fileSize)}</em>
										</button>
									</li>
								)
							})}
						</ul>
						}
					</div>

				}
			</div>
		</Layer>
	)
}

//조회필터
const FilterLayer = ({ show, closeLayer, commCodeTradeTp, setBeforeMonth, setParentTradeStartDe, setParentTradeEndDe, setParentTradeTp, setParentAnswerCd, answerStatus, target, activeTab }) => {
	const [tradeMonth, setTradeMonth] = useState(1); // 거래 몇개월전
	const [startDate, setStartDate] = useState(Lib.getCalMonthDate(-1));
	const [endDate, setEndDate] = useState(Lib.getToDate());
	const [tradeTp, setTradeTp] = useState(); // 문의구분
	const [answerTp, setAnswerTp] = useState(); //문의상태
	const [morePage, setMorePage] = useRecoilState(moreQuestPost);

	useEffect(() => {
		if (activeTab === 1) {
			setTradeMonth(1)
			setTradeTp("")
			setAnswerTp("")
		}
	}, [activeTab])

	return (
		<LayerBottom title="필터" show={show} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => {
				setBeforeMonth(tradeMonth);
				setParentTradeStartDe(startDate);
				setParentTradeEndDe(endDate);
				setParentTradeTp(tradeTp);
				setParentAnswerCd(answerTp);
				setMorePage(1)
				closeLayer()
			}}>확인</Button>
		}>
			<ul className="filter-option">
				<li>
					<p>조회기간</p>
					<ul className="opt-menu mt_10">
						<li className={tradeMonth === 1 ? "active" : ""}
							onClick={() => {
								setTradeMonth(1);
								setStartDate(Lib.getCalMonthDate(-1));
								setEndDate(Lib.getToDate());
							}}
						>1개월</li>
						<li className={tradeMonth === 3 ? "active" : ""}
							onClick={() => {
								setTradeMonth(3);
								setStartDate(Lib.getCalMonthDate(-3));
								setEndDate(Lib.getToDate());
							}}
						>3개월</li>
						<li className={tradeMonth === 6 ? "active" : ""}
							onClick={() => {
								setTradeMonth(6);
								setStartDate(Lib.getCalMonthDate(-6));
								setEndDate(Lib.getToDate());
							}}
						>6개월</li>
						<li className={tradeMonth === 0 ? "active" : ""}
							onClick={() => {
								setTradeMonth(0);
								setStartDate("");
								setEndDate("");
							}}
						>직접설정</li>
					</ul>
					{/* 직접설정 선택 시 달력 노출 */}
					<div className="flex-align_center mt_10">
						<input type="date" id="inputStateDate" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
						<span style={{ margin: "0 0.5rem" }}>-</span>
						<input type="date" id="inputEndDate" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
					</div>
				</li>
				<li>
					<p>문의구분</p>
					<ul className="opt-menu mt_10">
						<li className={Lib.isNull(tradeTp) || tradeTp === "" ? "active" : ""}
							onClick={() => {
								setTradeTp("");
							}}
						>전체</li>
						{
							Lib.isNotNull(commCodeTradeTp) && commCodeTradeTp.length > 0 &&
							commCodeTradeTp.map((item, idx) => {
								return (
									<li key={idx} className={item.value === tradeTp ? "active" : ""}
										onClick={() => {
											setTradeTp(item.value);
										}}
									>{item.key}</li>
								)
							})
						}
					</ul>
				</li>
				<li>
					<p>답변상태</p>
					<ul className="opt-menu mt_10">
						<li className={Lib.isNull(answerTp) || answerTp === "" ? "active" : ""}
							onClick={() => {
								setAnswerTp("");
							}}
						>전체</li>
						{
							Lib.isNotNull(answerStatus) && answerStatus.length > 0 &&
							answerStatus.map((item, idx) => {
								return (
									<li key={idx} className={item.value === answerTp ? "active" : ""}
										onClick={() => {
											setAnswerTp(item.value);
										}}
									>{item.key}</li>
								)
							})
						}
					</ul>
				</li>
			</ul>
		</LayerBottom>
	)
}

const TermsLayer = ({ show, closeLayer, questType }) => {
	return (
		<LayerBottom title="개인정보 수집 및 이용동의 안내" show={show} closeLayer={closeLayer}>
			<div>
				<div>(주)핀테크는 {questType === 0 ? "이용자문의" : "사업제휴문의"}를 처리하기 위해 다음과 같이 개인정보를 수집/이용하며, 이용자의 개인정보를 안전하게 취급하는데 최선을 다하고 있습니다.</div>
				<table className="table-line mt_20">
					<colgroup>
						<col width="30.614%" />
						<col />
					</colgroup>
					<tbody>
						<tr>
							<th>수집항목</th>
							<td>{questType === 0 ? "답변 받을 이메일 주소" : "회사명, 담당자명, 연락처, 이메일주소"}</td>
						</tr>
						<tr>
							<th>수집목적</th>
							<td>문의/요청/불편사항 확인 및 처리결과 회신</td>
						</tr>
						<tr>
							<th>보유기간</th>
							<td>3년간 보관 후 지체없이 파기</td>
						</tr>
					</tbody>
				</table>
				<div className="mt_20">위 동의를 거부할 권리가 있으며, 동의를 거부하실 경우 문의 처리 및 결과회신이 제한됩니다.</div>
			</div>
		</LayerBottom>
	)
}

export default Question